<template>
  <v-app-bar color="white" elevation=0>
      <v-btn :href="frontendUrl">
         <v-app-bar-title v-if="!demoVariant">
            <img :src="inletsLogo" alt="inlets.ai" class="brand-logo-img" />
         </v-app-bar-title>
         <v-app-bar-title v-else>
            <v-img width="120" :src="variantImage"></v-img>
         </v-app-bar-title>
      </v-btn>
   </v-app-bar>
   <v-app>
      <v-main>
         <v-container class="fill-height">
            <v-row align="center" justify="center" class="fill-height">
               <v-col cols="12" sm="8" md="6">
                  <v-card class="pa-4">
                     <v-card-title class="text-center">
                        <h3 style="font-family: 'Poppins', sans-serif;">Login</h3>
                     </v-card-title>
                     <v-card-text>
                     <v-form v-model="isFormValid">
                        <v-text-field
                           v-model="loginEmail"
                           color="primary"
                           label="Email"
                           variant="outlined"
                           :rules="emailRules"
                           :disabled="isDemo"
                           prepend-inner-icon="mdi-email-outline"
                        ></v-text-field>
                        <v-text-field
                           v-model="loginPassword"
                           color="primary"
                           type="password"
                           label="Password"
                           variant="outlined"
                           :rules="passwordRules"
                           :disabled="isDemo"
                           prepend-inner-icon="mdi-lock-outline"
                        ></v-text-field>
                        <p class="pl-2" style="color: red">{{ loginError }}</p>
                     </v-form>
                     </v-card-text>
                     <v-card-actions class="px-6 pt-0 pb-4">
                        <v-row v-if="loading" align="center" justify="center">
                           <v-progress-circular
                              :size="42"
                              :width="6"
                              color="primary"
                              indeterminate
                           ></v-progress-circular>
                        </v-row>
                        <v-row v-else>
                           <span>
                              <v-btn :disabled="!isFormValid" @click="login" color='orange'>{{ loginText }}</v-btn>
                              <v-btn v-if="!isDemo" @click="toSignup" color="primary">Create Account</v-btn>
                           </span>
                        </v-row>
                     </v-card-actions>
                     <v-row v-if="!isDemo">
                        <v-divider class="mx-8 my-4">
                        </v-divider>
                     </v-row>
                     <v-row v-if="!isDemo" class="pb-6" justify="center">
                        <GoogleSignInButton
                           @success="handleGoogleLoginSuccess"
                           @error="handleGoogleLoginError"
                        ></GoogleSignInButton>
                     </v-row>
                     <v-row v-if="!isDemo"  justify="center" align="center" class="py-6">
                        <a href="/forgotPassword" class="forgot-password">Forgot your password?</a>
                     </v-row>
                  </v-card>
               </v-col>
            </v-row>
       </v-container>
     </v-main>
   </v-app>
 </template>
 
<script>
import { mapActions, mapGetters } from "vuex";
import router from "@/router";
import { GoogleSignInButton } from "vue3-google-signin";
import demoVariantList from "@/const.js";
import inletsLogo from "@/assets/images/inlets-logo-color.svg";

export default {
   name: 'Login',
   computed: {
      ...mapGetters(["getAuthToken", "getUserEmail", "getUserID", "isLoggedIn"]),
      frontendUrl() {
         return process.env.VUE_APP_FRONTEND_URL
      },
      loginError() {
         return this.$store.state.auth.login_error
      },
      loading() {
         return this.$store.state.auth.login_loading
      },
      isDemo() {
         return process.env.NODE_ENV === 'demo'
      },
      loginText() {
         return this.isDemo ? "Log into Demo" : "Login"
      },
      variantImage() {
         if (demoVariantList[this.demoVariant]) {
            return demoVariantList[this.demoVariant].imageUrl
         }
      },
      demoColor() {
         if (demoVariantList[this.demoVariant]) {
            return demoVariantList[this.demoVariant].color
         }
      }
   },
   data() {
      return {
         inletsLogo,
         isFormValid: false,
         loginEmail: "",
         loginPassword: "",
         emailRules: [
            v => !!v || "Please enter a valid email",
            v => /.+@.+\..+/.test(v) || "Invalid email format",
         ],
         passwordRules: [
            v => !!v || "Password required",
         ],
         demoVariant: null,
      };
   },
   mounted() {
      if (this.isDemo) {
         let urlParams = new URLSearchParams(window.location.search);
         let demo_variant = urlParams.get('demo_variant');
         if (!demo_variant) {
            demo_variant = localStorage.getItem('demo_variant');
         }
         if (demo_variant && demoVariantList[demo_variant]) {
            localStorage.setItem('demo_variant', demo_variant)
            this.demoVariant = demo_variant;
         } else {
            this.demoVariant = null;
         }
      }
   },
   created() {
      if (this.isDemo) {
         this.loginDemoAccount();
      }
   },
   methods: {
      ...mapActions(["loginUser", "googleSignUp"]),
      async login(event) {
         this.$store.state.auth.login_error = "";
         if (event) {
            event.preventDefault();
         }
         let data = {
               user: {
                  email: this.loginEmail,
                  password: this.loginPassword,
               },
         };
         await this.loginUser(data);
      },
      resetData() {
         this.loginEmail = "";
         this.loginPassword = "";
      },
      toSignup() {
         this.$store.state.auth.login_error = "";
         router.push({ name: 'Signup' });
      },
      async handleGoogleLoginSuccess(response) {
         this.$store.commit("setLoginError", "");
         try {
            await this.googleSignUp(response);
         } catch (error) {
            this.$store.commit(
               "setLoginError",
               error.response?.data?.message || "There was a problem signing you in with Google."
            );
         }
      },
      handleGoogleLoginError() {
         console.error("Login failed");
      },
   }
}
</script>
 <style scoped>
 .forgot-password {
    font-size: 15px;
    font-family: 'Poppins', sans-serif;
    text-align: center;
    color: #65647C;
    text-decoration: none;
 }
 </style>
 